import { render, staticRenderFns } from "./PaymentTransactionsGivenList.vue?vue&type=template&id=0df1c0b6"
import script from "./PaymentTransactionsGivenList.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionsGivenList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports